import React, { useState, useEffect, useContext } from 'react'
import { Button } from 'react-bootstrap';
// import { Table, Button } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import styles from './InquirieContact.module.css';
import AlertContext from '../../../context/AlertModelContext/AlertModalContext';
// import PaginationComponent from '../../UI/Pagination/PaginationComponent';
import { getInquiriesForSpecificContactPerson } from '../../../axios/requests/inquiresReq';
import { formatDateFromDB, formatDuration } from '../../../util/functions';
import Flatpickr from 'react-flatpickr';
import heLocale from 'flatpickr/dist/l10n/he';
import 'flatpickr/dist/themes/material_green.css';
import { itemsPerPagePagination } from '../../../settings'
import { useSearchInquiresContext } from '../../../context/SearchContactInquires/SearchContactInquires';
import Grid from '../../UI/Grid/Grid';

const InquirieContact = (props) => {
  const alertCtx = useContext(AlertContext);
  const { searchInquires, setSearchInquires } = useSearchInquiresContext();
  const [t] = useTranslation('common');

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(itemsPerPagePagination || 9);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentInquires = searchInquires?.inquires?.slice(indexOfFirstItem, indexOfLastItem) || [];

  const paginate = pageNumber => setCurrentPage(pageNumber);

  const handleSubmit = async (e) => {
    e.preventDefault();
    await fetchAllInquires();
  };

  const fetchAllInquires = async () => {
    let newContactId;
    if (props.contactListMode === 'edit') {
      if (props.nowSelectedContact && props.whereTypped === 'CONTACT') {
        props.OnContactTabClicked('ContactList');
        newContactId = props.nowSelectedContact?._id;
      } else if (props.selectedConv && props.whereTypped === 'CONV') {
        props.OnContactTabClicked('Chat');
        newContactId = props.selectedConv?.contactId?._id;
      } else if (props.callSelected && props.whereTypped === 'DIALER') {
        props.OnContactTabClicked('Dialer');
        newContactId = props.callSelected?.callObj?.contactId?._id;
      } else if (props.dialItemSelected && props.whereTypped === 'DIALLIST') {
        props.OnContactTabClicked('DialList');
        newContactId = props.dialItemSelected?.dialListObj?.contactId?._id;
      }
      setSearchInquires(prevState => ({ ...prevState, contactId: newContactId }));

      if (!newContactId) {
        console.log("No contact ID available");
        return;
      }

      let response = await getInquiriesForSpecificContactPerson(newContactId, searchInquires.msgType, '-startTime', searchInquires.agentName, searchInquires.startDate, searchInquires.status);
      if (response && response.status === "success") {
        let responseData = response.data.data;
        setSearchInquires(prevState => ({
          ...prevState,
          inquires: Array.isArray(responseData) ? responseData : []
        }));
      } else {
        console.error("Failed to fetch inquiries:", response);
        setSearchInquires(prevState => ({ ...prevState, inquires: [] }));
      }
    }
  };

  useEffect(() => {
    fetchAllInquires();
  }, [props.nowSelectedContact, props.contactListMode, props.whereTypped, props.selectedConv, props.callSelected, props.dialItemSelected, searchInquires.contactId]);

  const maxDate = new Date();
  const minDate = new Date();
  minDate.setMonth(minDate.getMonth() - 3);
  minDate.setHours(0, 0, 0, 0);

  const headers = [
    { label: t('Inquire startTime'), className: 'activityNumber' },
    { label: t('Inquire msgType'), className: 'activityDate' },
    { label: t('Inquire type'), className: 'activityNumber' },
    { label: t('Inquire clientName'), className: 'activityRemarks' },
    { label: t('Inquire answerAgent'), className: 'activityDate' },
    { label: t('Inquire answerTime'), className: 'activityNumber' },
    { label: t('Inquire closeTime'), className: 'activityNumber' },
    { label: t('Inquire status'), className: 'activityNumber' },
    { label: t('Inquire Duration'), className: 'activityNumber' },
    { label: t('Inquire Correspondence'), className: 'activityNumber' },
  ];

  const renderRow = (inquire, index) => (
    <tr key={inquire._id}>
      <td>{formatDateFromDB(inquire?.startTime)}</td>
      <td>{inquire?.msgType}</td>
      <td>{t(inquire?.type)}</td>
      <td>{inquire?.clientName}</td>
      <td>{inquire.answerAgent ? (inquire.answerAgent.name || "") : ""}</td>
      <td>{inquire.answerTime ? formatDateFromDB(inquire.answerTime) : ""}</td>
      <td>{inquire.closeTime ? formatDateFromDB(inquire.closeTime) : ""}</td>
      <td>{t(inquire?.status)}</td>
      <td>{formatDuration(inquire?.durationSec)}</td>
      <td>
        {['sms', 'mail', 'whatsapp'].includes(inquire.msgType.toLowerCase()) ? (
          <i
            onClick={() => {
              props.openNewApiConvByMsgTypeAndClientName(
                inquire?.msgType,
                inquire?.clientName,
                null,
                inquire?.startTime,
                inquire?.closeTime
              );
              props.onHide();
            }}
            className={`fa-regular fa-comment ${styles.iconClickable}`}
          ></i>
        ) : (
          '-'
        )}
      </td>
    </tr>
  );

  return (
    <div>
      <div className={styles.flexItems}>
        <label htmlFor="startDate">{t('Filter startTime')}</label>
        <Flatpickr
          className={styles.dropdownFixedWidth}
          id="notification-time-picker"
          options={{
            time_24hr: true,
            enableTime: true,
            static: true,
            locale: heLocale.he,
            dateFormat: 'd/m/Y H:i',
            minDate: minDate,
            maxDate: maxDate,
          }}
          value={searchInquires?.startDate}
          onChange={(dates) => setSearchInquires(prevState => ({ ...prevState, startDate: dates[0] }))}
        />

        <label htmlFor="messageType">{t('Inquire msgType')}</label>
        <select
          id="messageType"
          className={styles.dropdownFixedWidth}
          value={searchInquires?.msgType || ''}
          onChange={(e) => {
            const newValue = e.target.value;
            setSearchInquires(prevState => ({ ...prevState, msgType: newValue }));
          }}
        >
          <option value="">{t('MsgType All')}</option>
          <option value="mail">Mail</option>
          <option value="whatsapp">WhatsApp</option>
          <option value="sms">SMS</option>
          <option value="telephony">Telephony</option>
        </select>

        <label htmlFor="agentName">{t('Inquire answerAgent')}</label>
        <select
          id="agentName"
          className={styles.dropdownFixedWidth}
          value={searchInquires?.agentName || ''}
          onChange={(e) => {
            const newValue = e.target.value;
            setSearchInquires(prevState => ({ ...prevState, agentName: newValue }));
          }}
        >
          <option value="">{t('All Agents')}</option>
          {props.agentsList && props.agentsList.map((agent) => (
            <option key={agent.id} value={agent?.agentName}>{agent.name}</option>
          ))}
        </select>

        <label htmlFor="status">{t('Inquire status')}</label>
        <select
          id="status"
          className={styles.dropdownFixedWidth}
          value={searchInquires?.status || ''}
          onChange={(e) => {
            const newValue = e.target.value;
            setSearchInquires(prevState => ({ ...prevState, status: newValue }));
          }}
        >
          <option value="">{t('All Status')}</option>
          <option value="pending">{t('pending')}</option>
          <option value="new">{t('new')}</option>
          <option value="closed">{t('closed')}</option>
        </select>

        <Button className='btn-success' type='submit' onClick={handleSubmit}>{t('Search')}</Button>
      </div>

      <Grid
        headers={headers}
        data={currentInquires}
        renderRow={renderRow}
        itemsPerPage={itemsPerPage}
        totalItems={searchInquires?.inquires?.length || 0}
        paginate={paginate}
        currentPage={currentPage}
        headerStyles={styles}
      />
    </div>
  );
}

export default InquirieContact;